<template>
  <full-page-modal
    ref="modal"
    show
    ok-only
    hide-header-close
    header-bg-variant="primary"
    header-class="text-white"
    :title="$t('request.fields.customer')"
    @cancel="$emit('cancel', $event)"
    @ok="$emit('ok', $event)"
    @hidden="$emit('hidden', $event)"
  >
    <form>
      <customer-form-field
        :label="$t('request.fields.customer')"
        required
        :value="value.customer"
        :error="findError('customer')"
        @input="propertyChange('customer', $event)"
      />

      <!--
      <network-form-field
        :label="$t('request.fields.network')"
        required
        :value="value.network"
        :error="findError('network')"
        @input="propertyChange('network', $event)"
      />
      -->
    </form>
    <!--<template slot="modal-footer">

    </template>-->
  </full-page-modal>
</template>
<script>
import CustomerFormField from "@/modules/customer/protected/CustomerFormField";
//import NetworkFormField from '@/modules/network/protected/NetworkFormField';
import EditorMixin from "vue-template/common/mixins/EditorMixin";

export default {
  mixins: [EditorMixin],

  components: {
    CustomerFormField
    //NetworkFormField
  },

  methods: {
    hide() {
      this.$refs.modal.hide();
    },

    show() {
      this.$refs.modal.show();
    }
  }
};
</script>
